import React from 'react';
export const Problem = () => {
  return <section className="mb-10" data-id="element-196">
      <p className="mb-6 text-lg leading-relaxed" data-id="element-197">
        Het was een doordeweekse ochtend toen Sandra me belde, haar stem
        trillend van emotie. "Amee, ik weet niet meer wat ik moet doen. Gisteren
        trok Benny me letterlijk omver tijdens het wandelen. Ik lag op de grond,
        omringd door andere hondeneigenaren die me medelijdend aankeken. Ik
        schaamde me zo erg dat ik de rest van de dag heb gehuild."
      </p>
      <div className="w-full mb-6" data-id="element-198">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3JyaDPTDobRjD5WRihmtQh/Scherm%C2%ADafbeelding_2025-08-15_om_15.32.12.png" alt="Innig moment tussen een man en zijn golden retriever die elkaar aandachtig aankijken" className="w-full h-auto rounded-lg shadow-md" data-id="element-199" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-200">
          Een hond kijkt meer naar wat je met je lichaam zegt, dan dat je met je
          woorden zegt.
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-201">
        Sandra's verhaal is niet uniek. Als gediplomeerd niveau 5
        hondengedragsconsultant, opgeleid bij Calming Signs in Koningslust, heb
        ik in de afgelopen jaren meer dan 15.000 Nederlandse en Vlaamse baasjes
        geholpen. Hun verhalen zijn vaak hetzelfde: liefdevol, toegewijde mensen
        die alles voor hun hond over hebben, maar die zich machteloos voelen
        omdat ze maar niet die diepe verbinding kunnen krijgen waar ze zo naar
        verlangen.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-202">
        En na jaren van onderzoek, waarbij ik 27 wetenschappelijke studies
        bestudeerde en duizenden uren doorbrracht met observeren van
        hond-eigenaar relaties, ontdekte ik iets schokkends dat alles verklaart.
      </p>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-203">
        De Pijnlijke Waarheid Die Elke Hondeneigenaar Kent
      </h2>
      <p className="mb-4 leading-relaxed" data-id="element-204">
        Misschien herken je jezelf in Sandra's verhaal. Of misschien klinken
        deze situaties bekend:
      </p>
      <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-205">
        <p className="mb-4 italic" data-id="element-206">
          Je staat in het park en je hond begint weer oncontroleerbaar te
          blaffen naar andere honden. Alle ogen zijn op jou gericht. Je voelt de
          warme blos van schaamte over je wangen kruipen terwijl je wanhopig
          probeert je hond tot de orde te roepen. "Sorry, sorry!" roep je naar
          de andere eigenaren, terwijl je je afvraagt waarom jouw hond zich zo
          gedraagt.
        </p>
        <p className="mb-4 italic" data-id="element-207">
          Of die momenten thuis wanneer je hond voor de zoveelste keer niet
          luistert naar je 'af' commando. Je hebt het al tien keer gezegd,
          steeds luider, steeds geïrriteerder. En dan komt die vreselijke
          gedachte: "Ben ik gewoon een slechte hondeneigenaar?"
        </p>
        <p className="mb-4 italic" data-id="element-208">
          De constante stress tijdens wandelingen waarbij je hond aan de riem
          trekt alsof zijn leven ervan afhangt. Je arm doet pijn, je rug spaant
          op, en elke wandeling voelt aan als een gevecht in plaats van een
          ontspannen moment samen.
        </p>
        <p className="italic" data-id="element-209">
          Het ergste van alles? Die steek van twijfel die 's nachts komt:
          "Verdien ik deze hond wel? Kan ik hem wel geven wat hij nodig heeft?"
        </p>
      </div>
      <p className="font-semibold text-blue-800" data-id="element-210">
        Deze gevoelens - van overweldiging, onzekerheid, schuld, schaamte en
        machteloosheid - zijn niet jouw schuld. Ze zijn het gevolg van iets wat
        ik de 'Verborgen Taalbarrière' noem.
      </p>
      <h2 className="text-xl font-bold text-blue-800 my-6" data-id="element-211">
        Waarom Traditionele Methoden Falen
      </h2>
      <p className="mb-4 leading-relaxed" data-id="element-212">
        Voordat ik verder ga, wil ik even stil staan bij waarom je
        waarschijnlijk al zoveel hebt geprobeerd zonder het gewenste resultaat.
      </p>
      <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-213">
        <li data-id="element-214">
          Traditionele hondenscholen zijn vaak te druk en chaotisch, vooral voor
          gevoelige honden die al overprikkeld zijn. Ze hanteren meestal nog
          steeds een one-size-fits-all aanpak, terwijl elke hond uniek is.
        </li>
        <li data-id="element-215">
          Privé gedragstherapeuten kunnen fantastisch zijn, maar kosten al snel
          €100+ per sessie. Voor veel gezinnen is dit financieel niet haalbaar.
        </li>
        <li data-id="element-216">
          Andere online cursussen zijn vaak te theoretisch en niet
          praktijkgericht genoeg. Ze focussen op gehoorzaamheid in plaats van
          communicatie.
        </li>
      </ul>
      <p className="font-semibold" data-id="element-217">
        Het probleem met al deze methoden? Ze behandelen de symptomen, niet de
        onderliggende oorzaak van de problemen tussen jou en je hond.
      </p>
    </section>;
};